module.exports = __webpack_public_path__ + "static/media/smartphone.aab12817.svg";